/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

/**
 * S494: Added role="status" and visually-hidden "Loading..." text.
 * Without these, screen readers receive no announcement when a Suspense
 * boundary or auth guard renders this spinner — users relying on assistive
 * technology have no way to know the page is loading rather than broken.
 *
 * role="status" is a live region that politely announces its content when
 * it is inserted into the DOM, which is exactly the right semantics for a
 * loading state. The sr-only span carries the visible label for screen
 * readers without affecting the visual layout.
 */

export const Loading = () => (
  <div
    className="flex h-screen w-full items-center justify-center"
    role="status"
    aria-label="Loading"
  >
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500" />
    <span className="sr-only">Loading…</span>
  </div>
);
